import { render, staticRenderFns } from "./USDT-BINANCE.vue?vue&type=template&id=aa5b7224&scoped=true"
import script from "./USDT-BINANCE.vue?vue&type=script&lang=js"
export * from "./USDT-BINANCE.vue?vue&type=script&lang=js"
import style0 from "./USDT-BINANCE.vue?vue&type=style&index=0&id=aa5b7224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5b7224",
  null
  
)

export default component.exports